import AppService from '@/services/AppService.js'
const namespaced = true
const state = {
    customer_list: [],
    product_list: [],
    price_list: [],
    tax_list: [],
    tag_list: [],
    is_no_records: '',
    code: '',
    updated_id: '',
    lists: {},
    total_count: '',
    updatedtag_id: '',
    count: 1,
    list: {},
    state_list: [],
    org_state: '',
    sales_person_list: [],
    eqmnt_list: [],
    pjt_list: [],
    pymnt_trm_list: [],
    export_type_list: [],
    location_detail: [],
    search_criteria: '',
    email: {},
    inv_status_list: [],
    quot_status_list: [],
    filter_list: {},
    filter_name: '',
    message: {},
    seller_gst_detail: '',
    gst_type_list: {},
    rec_inv_status_list: {},
    log_details: '',
    auto_generate_code: {},
    active_code_id: {},
    export: {},
    tax_main: [],
    exempt_reason_list: [],
    type: '',
    status_code: '',
    status_message: '',
    status_type: '',
    sales_index_history:'',
    index_status:''

}
const mutations = {
    SALES_LIST(state, data) {
        state.customer_list = data.customer
        state.product_list = data.product
        state.price_list = data.price_list
        state.tax_list = data.tax_list
        state.tag_list = data.tag_list
        state.org_state = data.org_state
        state.state_list = data.state_list
        state.sales_person_list = data.sales_person_list
        state.pjt_list = data.pjt_list
        state.pymnt_trm_list = data.pymnt_trm_list
        state.inv_status_list = data.inv_status_list
        state.crdt_status_list = data.crdt_status_list
        state.quot_status_list = data.quot_status_list
        state.seller_gst_detail = data.seller_gst_detail
        state.gst_type_list = data.gst_type_list
        state.export_type_list = data.export_type_list
        state.rec_inv_status_list = data.rec_inv_status_list
        state.auto_generate_code = data.auto_generate_code
        state.active_code_id = data.active_code_id
        state.location_detail = data.location_detail
        state.tax_main = data.tax_main
        state.exempt_reason_list = data.exempt_reason_list

    },
    TAG_LIST(state, data) {
        state.tag_list = data
    },
    STATUS_CODE(state, code) {
        state.code = code
    },
    LIST_ID(state, updated_id) {
        state.updated_id = updated_id
    },
    UPDATED_TAG(state, updated_id) {
        state.updatedtag_id = updated_id
    },
    LIST_DATA(state, list) {
        state.list = list
    },
    SET_DATAS(state, lists) {
        state.lists = lists.quot_list
        state.total_count = lists.total_count
        state.count = lists.show
        state.search_criteria = lists.search
        state.filter_list = lists.filter_list
        state.filter_name = lists.filter_name
        state.is_no_records = lists.is_no_records
    },
    SALES_PERSON_LIST(state, data) {
        state.sales_person_list = data
    },
    PROJECT_LIST(state, data) {
        state.pjt_list = data
    },
    EMAIL_RESULT(state, email_result) {
        state.email = email_result
    },
    LIST_LOG(state, data) {
        state.log_details = data
    },
    CANCEL_STATUS(state, data) {
        state.message = data
        state.error = ''
    },
    EXPORT_DATAS(state, lists) {
        state.export = lists
    },
    MESSAGE_DETAILS(state, data) {
        state.message = data.status
        state.type = data.type
    },
    SET_CODE(state, data) {
        state.status_code = data.code;
        state.status_message = data.status;
        state.status_type = data.type;
    },


}
const actions = {
    fetchLists({
        commit,
        rootState
    }, {
        page,
        show,
        search,
        status,
        sort,
        label,
        from_date,
        to_date,
        custom
    }) {

        return AppService.sales.getSales(page, show, search, status, sort, label, from_date, to_date, custom, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                }else if (response.data.code != 404) {
                    commit("SET_CODE", response.data);
                    commit("SET_DATAS", response.data.data); // getting all the list in the api call
                  } else {
                    commit("SET_CODE", response.data);
                  }
                    return response
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    convertdraft({
        commit,
        rootState
    }, data) {

        return AppService.sales.getSalesDraft(data, rootState.session.token)
            .then(response => {
                commit('STATUS_CODE', response.status)
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                }
                return response
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
                return error
            })
    },
    fetchexportLists({
        commit,
        rootState
    }, {
        page,
        show,
        search,
        status,
        sort,
        label,
        from_date,
        to_date,
        custom
    }) {

        return AppService.sales.getSalesExport(page, show, search, status, sort, label, from_date, to_date, custom, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('EXPORT_DATAS', response.data.list) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    updateList({
        commit,
        rootState
    }, {
        id,
        field
    }) {

        return AppService.sales.postSalesUpdate(field, id, rootState.session.token)
            .then(response => {
                commit('STATUS_CODE', response.status)
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else if (response.status == 201) {
                    commit("STATUS_CODE", response.status); // getting all the list in the api call
                    commit('CANCEL_STATUS', response.data.data)
                    commit("SET_CODE", response.data);
                    commit('MESSAGE_DETAILS', response.data)

                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_ID', response.data.data)
                    commit('MESSAGE_DETAILS', response.data)
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchviewList({
        commit,
        rootState
    }, id) {

        return AppService.sales.getSaleView(id, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_DATA', response.data) // getting all the list in the api call

                }

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    changeStatus({
        commit,
        rootState
    }, {
        id,
        convertmodule
    }) {

        return AppService.sales.postChangeStatus(id, convertmodule, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('LIST_ID', response.data.data) // getting all the list in the api call
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchSalesDetails({
        commit,
        rootState
    }, data) {
        return AppService.sales.getSalesDetails(data, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    rootState.general.filterdetails = response.data.data
                    commit('SALES_LIST', response.data.data)
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    createList({
        commit,
        rootState
    }, list) {

        return AppService.sales.postSales(list, rootState.session.token)
            .then(response => {
                commit('STATUS_CODE', response.status)
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else if (response.status == 201) {
                    commit("STATUS_CODE", response.status); // getting all the list in the api call
                    commit('CANCEL_STATUS', response.data.data)
                    commit("SET_CODE", response.data);
                    commit('MESSAGE_DETAILS', response.data)

                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_ID', response.data.data)
                    commit('MESSAGE_DETAILS', response.data)
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchList({
        commit,
        rootState
    },   {
        id,
        page,
        type
    }) {
        return AppService.sales.getSale(id, page,type, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_DATA', response.data) // getting all the list in the api call

                }

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    addTag({
        commit,
        rootState
    }, tag_name) {
        return AppService.general.postTag(tag_name, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } 
                else if(response.status == 201) {
                    commit('UPDATED_TAG', response.data.updated_id)
                    commit('STATUS_CODE', response.status) 
                }else {
                    // rootState.salesorder.tag_list = response.data.data
                    commit('TAG_LIST', response.data.data) // getting all the list in the api call
                    commit('UPDATED_TAG', response.data.updated_id)
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                 
                }
                return response

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    addSalesPerson({
        commit,
        rootState
    }, field) {
        return AppService.general.postSalesPerson(field, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    rootState.credit.sales_person_list = response.data.data
                    rootState.amccontract.sales_person_list = response.data.data
                    commit('SALES_PERSON_LIST', response.data.data) // getting all the list in the api call
                    commit('UPDATED_TAG', response.data.updated_id)
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }
                return response
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    addProject({
        commit,
        rootState
    }, field) {
        return AppService.general.postProject(field, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('PROJECT_LIST', response.data.data) // getting all the list in the api call
                    commit('UPDATED_TAG', response.data.updated_id)
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }
                return response
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    filtercreateList({
        commit,
        rootState
    }, data) {

        return AppService.sales.postFiltercreateSales(data, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_ID', response.data.data) // getting all the list in the api call
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    filterdelete({
        commit,
        rootState
    }, data) {

        return AppService.sales.postFilterdeleteSales(data, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    filterupdateList({
        commit,
        rootState
    }, {
        id,
        data
    }) {

        return AppService.sales.postFilterudpateSales(data, id, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_ID', response.data.data) // getting all the list in the api call
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    bulkdelete({
        commit,
        rootState
    }, id) {

        return AppService.sales.postSalestBulkDelete(id, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_LOG', response.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    deletequotation({
        commit,
        rootState
    }, data) {

        return AppService.sales.getSalesDelete(data, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }
                return response
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
                return error
            })
    },
    approvequotation({
        commit,
        rootState
    }, data) {

        return AppService.sales.getQuotationApprove(data, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('LIST_ID', response.data.data) // getting all the list in the api call
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }
                return response
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
                return error
            })
    },
    accpetdeclinestatus({
        commit,
        rootState
    }, data) {

        return AppService.sales.changeAcceptDecline(data, rootState.session.token)
            .then(response => {
                commit('STATUS_CODE', response.status)
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                }
                return response
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
                return error
            })
    },
    quotationSettings({
        commit,
        rootState
    }, data) {
        return AppService.sales.quotSettingsUpdate(data, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }
                return response
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
                return error
            })
    },


}
export default {
    namespaced,
    state,
    mutations,
    actions
}